import api from './api';

export default class RecadastroDependenteService {
  constructor() {
    throw 'Não é possível instanciar RecadastroDependenteService';
  }

  static async lista(funcionarioId) {
    const endpoint = mergeEndpoint(`funcionarios/${funcionarioId}/dependentes`);
    return await api.get(endpoint);
  }

  static async listaTiposDependencia() {
    const endpoint = mergeEndpoint(`tipos-dependentes`);
    return await api.get(endpoint);
  }

  static async obtemDependente(funcionarioId, cpfDependente) {
    const endpoint = mergeEndpoint(`funcionarios/${funcionarioId}/dependentes/${cpfDependente}`);
    return await api.get(endpoint);
  }

  static async grava(dependente, anexos) {
    const endpoint = mergeEndpoint();

    const data = new FormData();
    data.append('dependente', JSON.stringify(dependente));

    if(anexos.length) {
      anexos.forEach((anexo, i) => data.append('anexos', anexo))
    }

    return await api.post(endpoint, data);
  }

  static async atualiza(id, dependente, anexos) {
    const endpoint = mergeEndpoint(id);

    const data = new FormData();
    data.append('dependente', JSON.stringify(dependente));

    if(anexos.length) {
      anexos.forEach((anexo, i) => data.append('anexos', anexo))
    }

    return await api.put(endpoint, data);
  }

  static async exclui(id) {
    return await api.delete(mergeEndpoint(id));
  }

}

const mergeEndpoint = value => {
  return `recadastro-dependentes/${value || ''}`;
};



// WEBPACK FOOTER //
// ./src/services/recadastroDependenteService.js